import React from "react";
import USVideo from "../assets/US.mp4";
import HeroBg from "../assets/heroBg.png";

export default function Hero() {
    return (
        <section className="relative w-full min-h-screen flex flex-col items-center pt-10 pb-16 overflow-hidden bg-[#EEF6FD]">

            <div
                className="absolute z-0 pointer-events-none"
                style={{
                    top: '0%',
                    left: '0%',
                    width: '55%',
                    height: '100%',
                    backgroundImage: `url(${HeroBg})`,
                    backgroundSize: 'auto 100%', 
                    backgroundPosition: 'left top',
                    backgroundRepeat: 'no-repeat',
                    filter: 'blur(18px)',
                    transform: 'scale(1.04)',
                    transformOrigin: 'left top',
                    opacity: 0.95,
                }}
            />

            {/* Fade the right edge of the blob smoothly into bg */}
            <div
                className="absolute inset-0 z-0 pointer-events-none"
                style={{
                    background: 'linear-gradient(to right, transparent 25%, #EEF6FD 52%)',
                }}
            />

            <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center flex flex-col items-center">
                <h1 className="font-jakarta font-extrabold text-[40px] md:text-[49.1px] text-[#191E49] leading-[1.15] md:leading-[60px] tracking-tight mb-6">
                    One Stop Shop for Glow.
                </h1>

                <p className="text-[#0B1238] font-medium max-w-4xl text-base md:text-[18px] leading-relaxed mb-8">
                    Book makeup artists, photographers, choreographers, and more all using the Wamglammz
                    portal to find qualified professionals and review their work before booking.
                </p>

                

                <div className="flex flex-wrap justify-center gap-4 mb-12">
                    {["CALENDAR", "ONLINE BOOKING", "SALES & PAYMENTS", "MARKETING"].map((label) => (
                        <span
                            key={label}
                            className="px-6 py-2.5 bg-white/30 text-[#334155] text-[12px] font-medium tracking-widest rounded-full border-[0.5px] border-white/70 backdrop-blur-md shadow-sm"
                        >
                            {label}
                        </span>
                    ))}
                </div>
            </div>

            {/* ── Video card ── */}
            <div className="relative z-10 mx-auto w-full max-w-[1450px] px-[5px] flex justify-center">
                <div className="w-full max-w-[1040px] h-[620px] md:h-[620px] rounded-[24px] overflow-hidden shadow-2xl bg-black">
                    <video
                        src={USVideo}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="w-full h-full object-cover"
                    />
                </div>
            </div>
        </section>
    );
}